import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAffiliation, useAuth } from '../index'

const { env } = window
const PER_PAGE = 10

const useAffiliationUsersSearch = ({ search, userType, page, sort }) => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { affiliation } = useAffiliation()

  const getUsers = async (affiliationId) => {
    const offset = (page - 1) * PER_PAGE
    const sortParams = sort.reduce((result, item) => {
      result += `&sort=${item.id}:${item.desc ? 'desc' : 'asc'}`
      return result
    }, '')
    const searchParam = search ? `&search=${search}` : ''
    const userTypeParam = userType ? `&userType=${userType}` : ''
    const url = encodeURI(
      `${env.apiUrl}/affiliations/${affiliationId}/users?max=${PER_PAGE}` +
        `&offset=${offset}${sortParams}${userTypeParam}${searchParam}`
    )
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['users', affiliation?.id, search, userType, page, sort],
    queryFn: () => getUsers(affiliation?.id),
    enabled: false,
    gcTime: 0
  })

  useEffect(() => {
    if (query.isError) {
      handleError(query.error, 'Error getting users')
    }
  }, [query.isError, query.error, handleError])

  return {
    users: query.data ? query.data.items : undefined,
    pageCount: query.data ? Math.ceil(query.data.count / PER_PAGE) : undefined,
    refetch: query.refetch
  }
}

export { useAffiliationUsersSearch }
